export var TitleSize;
(function (TitleSize) {
    TitleSize["Large"] = "16px";
    TitleSize["Small"] = "14px";
})(TitleSize || (TitleSize = {}));
export var TitleLineHeight;
(function (TitleLineHeight) {
    TitleLineHeight["Large"] = "24px";
    TitleLineHeight["Small"] = "20px";
})(TitleLineHeight || (TitleLineHeight = {}));
export var AmountSize;
(function (AmountSize) {
    AmountSize["Large"] = "42px";
    AmountSize["Small"] = "20px";
})(AmountSize || (AmountSize = {}));
export var AmountLineHeight;
(function (AmountLineHeight) {
    AmountLineHeight["Large"] = "49px";
    AmountLineHeight["Small"] = "24px";
})(AmountLineHeight || (AmountLineHeight = {}));
export var CurrencySize;
(function (CurrencySize) {
    CurrencySize["Large"] = "24px";
    CurrencySize["Small"] = "20px";
})(CurrencySize || (CurrencySize = {}));
//# sourceMappingURL=Sizes.js.map